import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function InvalidUploadNotification(props) {
  return (
    <Notification dismiss={props.dismiss} title="Oops!">
      <p className="ndx-cta1">
        Sorry, we couldn’t display your existing upload. Please upload your art
        again.
      </p>
      <Button
        size="large"
        variant="secondary"
        className="notification-cta"
        href="#/uploadForm"
        onClick={props.dismiss}>
        Upload Art
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

InvalidUploadNotification.propTypes = propTypes;

InvalidUploadNotification.displayName = 'InvalidUploadNotification';
